import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import FullPageLoader from "../component/common/FullPageLoader";
import ForbiddenPage from "../component/Error/ForbiddenPage";
import { useLoginUser } from "../hooks/useLoginUser";
import { AppUserRoleType } from "../types/roles";

type RoleGuardProps = {
  allowedRoles: AppUserRoleType[];
};

const RoleGuard = ({ allowedRoles }: RoleGuardProps) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const { user } = useLoginUser();

  useEffect(() => {
    if (!user) return;

    if (allowedRoles.includes(user.role)) {
      setIsAuthorized(true);
    } else {
      setIsAuthorized(false);
    }
  }, [allowedRoles, user]);

  if (isAuthorized === null) return <FullPageLoader />;
  if (!isAuthorized) {
    return <ForbiddenPage />;
  }

  return <Outlet />;
};

export default RoleGuard;
